<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div class="relative">
		<div ref="popupContainer">
			<!-- GENERER DYNAMIQUEMENT -->
		</div>
		<vs-popup
			:active.sync="showAlertPopup"
			title="Relances commerciales"
			style="z-index: 52999"
		>
			<AlertesCommercialesTable
				:key="refreshListKey"
				:sortUserId="isRcByUserId"
				:allSocieties="allSocieties"
				:allCollaborators="allCollaborators"
				:allCollaboratorsAvatar="allCollaboratorsAvatar"
				@refresh-counter="
					$acl.check('admin') || $acl.check('sadmin')
						? getAllNotifications()
						: getNotificationsByCommercialId()
				"
			/>
		</vs-popup>
		<vs-popup
			:active.sync="flexiblePopupActive"
			title="Flexible Prestation"
			style="z-index: 52999"
		>
			<FlexibleMissionTable
				:key="refreshListKey"
				:sortUserId="isRcByUserId"
				:allSocieties="allSocieties"
				:allCollaborators="allCollaborators"
				:allCollaboratorsAvatar="allCollaboratorsAvatar"
				@refresh-counter="
					$acl.check('admin') || $acl.check('sadmin')
						? getAllNotifications()
						: getNotificationsByCommercialId()
				"
			/>
		</vs-popup>
		<vs-popup
			:active.sync="showDatePopup"
			title="Sélectionner les dates à filtrer"
		>
			<DateFilter @close-form="closeDatePopup()" />
		</vs-popup>
		<div class="vx-navbar-wrapper" id="navWrapper" :class="classObj">
			<vs-navbar
				class="vx-navbar navbar-custom navbar-skelton"
				:color="navbarColorLocal"
				:class="textColor"
			>
				<!-- SM - OPEN SIDEBAR BUTTON -->
				<feather-icon
					class="sm:inline-flex xl:hidden cursor-pointer p-2"
					icon="MenuIcon"
					@click.stop="showSidebar"
				/>

				<bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />

				<!-- <h1>{{ pageTitle }}</h1> -->
				<vs-breadcrumb separator="chevron_right">
					<li class="font-big-size">
						<a href="/" title="Home"
							><vs-icon
								icon="icon-home"
								icon-pack="feather"
								size="20px"
							></vs-icon></a
						><span
							v-if="breadcrumData.length > 0"
							class="vs-breadcrum--separator"
							>></span
						>
					</li>
					<li
						class="font-big-size"
						:key="index"
						v-for="(row, index) of breadcrumData"
					>
						<strong :title="row.title" disabled color="black">{{
							row.title
						}}</strong
						><span
							v-if="index < breadcrumData.length - 1"
							class="vs-breadcrum--separator"
							>></span
						>
					</li>
				</vs-breadcrumb>
				<vs-spacer />
				<!-- SELECT SOCIETY -->

				<!-- <vx-input-group class="bottom mr-1" v-if="showStatFilters">
          <vs-select
            v-model="userSelectedSociety"
            class="w-full select-medium mr-2"
            placeholder="Societé"
            autocomplete
          >
            <vs-select-item
              :key="index"
              :value="item"
              :text="item.name"
              v-for="(item, index) in userSocietiesOptions"
              class="w-full"
            />
          </vs-select>
          <template slot="append">
            <div v-if="userSelectedSociety !== null && $acl.check('accountmanager')" class="append-text bg-primary">
              <span class="flex"
                ><vs-button @click="showSocietyPopup">Détails</vs-button></span>
            </div>
          </template>
        </vx-input-group> -->
				<div
					class="font-big-size"
					:key="index"
					v-for="(row, index) of breadcrumData"
				>
					<vx-tooltip text="Budget Flexible">
						<vs-button
							v-if="
								index == 0 && activeUser.role != '2' && activeUser.type != '7'
							"
							color="dark"
							@click="flexiblePopUp()"
							style="
								margin-right: 20px;
								margin-top: 4px;
								background: transparent !important;
								padding: 0;
								overflow: visible;
							"
							id="alert-commercial"
						>
							<span class="material-symbols-outlined" style="color: #626262"
								>tenancy</span
							>
							<div
								v-if="flexibleMissionWaiting > 0"
								style="
									display: flex;
									justify-content: center;
									align-items: center;
									border-radius: 20px;
									width: 1.25rem;
									height: 1.25rem;
									top: -7px;
									right: -5px;
									background-color: rgb(234, 84, 85);
									color: white;
									font-size: 0.75rem;
									position: absolute;
								"
							>
								{{ flexibleMissionWaiting }}
							</div>
						</vs-button>
					</vx-tooltip>
				</div>
				<div
					class="font-big-size"
					:key="index"
					v-for="(row, index) of breadcrumData"
				>
					<vx-tooltip text="Message Commerciale">
						<vs-button
							v-if="
								index == 0 && activeUser.role != '2' && activeUser.type != '7'
							"
							color="dark"
							@click="onclickMessageConsultant()"
							style="
								margin-right: 20px;
								margin-top: 4px;
								background: transparent !important;
								padding: 0;
								overflow: visible;
							"
							id="alert-commercial"
						>
							<span class="material-symbols-outlined" style="color: #626262"
								>message</span
							>
							<div
								v-if="waiting_messages > 0"
								style="
									display: flex;
									justify-content: center;
									align-items: center;
									border-radius: 20px;
									width: 1.25rem;
									height: 1.25rem;
									top: -7px;
									right: -5px;
									background-color: rgb(234, 84, 85);
									color: white;
									font-size: 0.75rem;
									position: absolute;
								"
							>
								{{ waiting_messages }}
							</div>
						</vs-button>
					</vx-tooltip>
				</div>
				<div
					class="font-big-size"
					:key="index"
					v-for="(row, index) of breadcrumData"
				>
					<vx-tooltip text="Relance Commerciale">
						<vs-button
							v-if="
								index == 0 && activeUser.role != '2' && activeUser.type != '7'
							"
							color="dark"
							@click="relanceCommercialPopupNotifcation()"
							style="
								margin-right: 20px;
								margin-top: 4px;
								background: transparent !important;
								padding: 0;
								overflow: visible;
							"
							id="alert-commercial"
						>
							<span class="material-symbols-outlined" style="color: #626262"
								>currency_exchange</span
							>
							<div
								v-if="waiting_alert > 0"
								style="
									display: flex;
									justify-content: center;
									align-items: center;
									border-radius: 20px;
									width: 1.25rem;
									height: 1.25rem;
									top: -7px;
									right: -5px;
									background-color: rgb(234, 84, 85);
									color: white;
									font-size: 0.75rem;
									position: absolute;
								"
							>
								{{ waiting_alert }}
							</div>
						</vs-button>
					</vx-tooltip>
				</div>

				<!--
	<div class="box">
 <div class ="notification-box" >
    <span class="notification-count">6</span>
    <div class="notification-bell">
      <span class="bell-top"></span>
      <span class="bell-middle"></span>
      <span class="bell-bottom"></span>
      <span class="bell-rad"></span>
    </div>
 </div>
 -->

				<NotificationDropDown
					:listNotification="personalNotificationList"
					:newCount="newCountNotification"
					@rc-show-popup="relanceCommercialPopupNotifcation()"
				/>

				<!-- <vx-tooltip
			v-if="$acl.check('sadmin')"
			text="Réinitialiser le token Quickbooks"
			position="top"
			style="margin-right: 15px;"
		>
			<div class="btn-qb" @click="testConnection()" :style="'background-color:' + qbColor">qb</div>
		</vx-tooltip> -->
				<vs-button
					v-if="activeUser.role == '2'"
					color="#08B0B9"
					@click="displayContactForm"
					class="mr-2"
					><vs-icon icon="email" size="small"
				/></vs-button>
				<vs-select
					v-if="showSocietyFilter"
					v-model="userSelectedSociety"
					class="mr-1 select-large"
					placeholder="Société"
					autocomplete
				>
					<vs-select-item
						:key="index"
						:value="item"
						:text="item.name"
						v-for="(item, index) in userSocietiesOptions"
					/>
				</vs-select>

				<div
					v-if="
						showDateFilter && (statDateFilter.fromDate || statDateFilter.toDate)
					"
					class="mx-3"
				>
					<div>
						Du :
						<strong>{{
							statDateFilter.fromDate
								? statDateFilter.fromDate.split("-").reverse().join("/")
								: ""
						}}</strong>
					</div>
					<div>
						Au :
						<strong>{{
							statDateFilter.toDate
								? statDateFilter.toDate.split("-").reverse().join("/")
								: ""
						}}</strong>
					</div>
				</div>
				<!-- /SELECT SOCIETY -->
				<vs-button
					v-if="showDateFilter"
					color="#08B0B9"
					@click="displayDatePopup"
					class="mr-2"
					>Modifier la date</vs-button
				>

				<!-- <search-bar /> -->

				<!-- <notification-drop-down /> -->

				<profile-drop-down />
			</vs-navbar>
		</div>
	</div>
</template>


<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import Bookmarks from "./components/Bookmarks.vue";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";
import MessageConsultantPopup from "@/components/popups/MessageConsultantPopup";
/*
 * import SearchBar            from "./components/SearchBar.vue"
 * import NotificationDropDown from "./components/NotificationDropDown.vue"
 */
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import DateFilter from "./components/DateFilter.vue";
import AlertesCommercialesTable from "@/components/tables/AlertesCommercialesTable";
import FlexibleMissionTable from "@/components/tables/FlexibleMissionTable";
import store from "@/store/store";

import Notes from "@/entities/Notes";
import VxTooltip from "../vx-tooltip/VxTooltip.vue";

export default {
	name: "the-navbar-vertical",
	props: {
		navbarColor: {
			type: String,
			default: "#fff",
		},
	},
	components: {
		AlertesCommercialesTable,
		FlexibleMissionTable,
		MessageConsultantPopup,
		Bookmarks,
		/*
		 * SearchBar,
		 * NotificationDropDown,
		 */
		NotificationDropDown,
		ProfileDropDown,
		DateFilter,
		VxTooltip,
	},

	computed: {
		personalNotificationList() {
			return this.$store.state.personalNotification.data;
		},
		newCountNotification() {
			return this.$store.state.personalNotification.newCount;
		},
		apiUrl() {
			return this.$store.state.backendApiUrl;
		},
		navbarColorLocal() {
			return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
				? "#10163a"
				: this.navbarColor;
		},
		verticalNavMenuWidth() {
			return this.$store.state.verticalNavMenuWidth;
		},
		textColor() {
			return {
				"text-white":
					(this.navbarColor != "#10163a" &&
						this.$store.state.theme === "dark") ||
					(this.navbarColor != "#fff" && this.$store.state.theme !== "dark"),
			};
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		// NAVBAR STYLE
		classObj() {
			if (this.verticalNavMenuWidth == "default") return "navbar-default";
			else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced";
			else if (this.verticalNavMenuWidth) return "navbar-full";
		},
		// TITLE
		routeName() {
			return this.$route.name;
		},
		// DATA
		societies() {
			return this.$store.state.societies;
		},
		allSocieties: () => {
			return store.state.societies;
		},
		allFlexibleMissions: () => {
			return store.state.flexibleMissions;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		activeUserSociety() {
			return this.$store.state.activeUserSociety;
		},
		statDateFilter() {
			return this.$store.state.statDateFilter;
		},
		flexiblePopupActive: {
			get() {
				return this.$store.state.showFlexiblePopup;
			},
			set(value) {
				this.$store.commit("TOGGLE_FLEXIBLE_POPUP", value);
			},
		},
	},
	watch: {
		"$store.state.showFlexiblePopup": function (data) {
			if (!data) {
				this.clearQueryParams();
			}
		},
		allFlexibleMissions: function (data) {
			let waiting = data.filter((ele) => ele.flex_is_check == 0);
			this.flexibleMissionWaiting = waiting.length;
		},

		routeName: function () {
			this.getPageInfo();
			this.createSocietyList();
		},
		societies: {
			handler: function () {
				this.createSocietyList();
			},
			deep: true,
		},
		userSelectedSociety: function (data) {
			this.setSelectedSociety(data);
		},
		activeUser: function (data) {
			//console.log(data);
			if (data.role == 1) {
				let netlinkIndex = this.pagesTitleList.findIndex(
					(row) => row.url == "netlink"
				);
				if (netlinkIndex >= 0) {
					this.pagesTitleList[netlinkIndex].showSocietyFilter = false;
				}
			}
		},
		activeUserSociety: function (data) {
			//console.log(data);
			this.userSelectedSociety = data;
			//console.log(this.userSelectedSociety);
		},
	},

	data() {
		return {
			refreshListKey: 0,
			isRcByUserId: false,
			flexibleMissionWaiting: 0,
			pagesTitleList: [
				{
					title: "Contrats",
					url: "contracts",
					icon: "home",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["contracts"],
					disabled: false,
				},
				{
					title: "Gestion de Projet",
					url: "consultants",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["consultants"],
					disabled: false,
				},
				{
					title: "Clients",
					url: "society",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["society"],
					disabled: false,
				},
				{
					title: "Documents",
					url: "documents",
					showDateFilter: false,
					showSocietyFilter: true,
					loadAllSocieties: true,
					path: ["documents"],
					disabled: false,
				},
				{
					title: "Prospection",
					url: "prospects",
					showStatFilters: false,
					path: ["prospects"],
					disabled: false,
				},
				/*
				 * {
				 * title: "Tâches",
				 * url: "tasks",
				 * showDateFilter: false,
				 * showSocietyFilter: false,
				 * loadAllSocieties: true,
				 * path: ["tasks"],
				 * disabled: false,
				 * },
				 */
				{
					title: "Netlinking",
					url: "netlink",
					showDateFilter: false,
					showSocietyFilter: true,
					loadAllSocieties: true,
					path: ["netlink"],
					disabled: false,
				},
				{
					title: "Backlinks",
					url: "backlinks",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["backlinks"],
					disabled: false,
				},
				{
					title: "Noms de domaine",
					url: "dns",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["dns"],
					disabled: false,
				},
				{
					title: "Prestataires",
					url: "providers",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["providers"],
					disabled: false,
				},
				{
					title: "Achats",
					url: "purchases",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["purchases"],
					disabled: false,
				},
				{
					title: "Facturation",
					url: "invoices",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["invoices"],
					disabled: false,
				},
				{
					title: "Paramètres",
					url: "parameters",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["parameters"],
					disabled: true,
				},
				{
					title: "Prestations",
					url: "products",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["parameters", "products"],
					disabled: false,
				},
				{
					title: "Type de Netlinks",
					url: "netlink_types",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["parameters", "netlink_types"],
					disabled: false,
				},
				{
					title: "Netlinking",
					url: "netlink-thema",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["parameters", "netlink-thema"],
					disabled: false,
				},
				{
					title: "Collaborateurs",
					url: "collaborator",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["parameters", "collaborator"],
					disabled: false,
				},
				{
					title: "Contacts",
					url: "contact",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["parameters", "contact"],
					disabled: false,
				},
				{
					title: "Logs",
					url: "logs",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["parameters", "logs"],
					disabled: false,
				},
				{
					title: "Prospection",
					url: "prospects_settings",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["parameters", "prospects_settings"],
					disabled: false,
				},
				{
					title: "Exports",
					url: "exports",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["parameters", "exports"],
					disabled: false,
				},
				{
					title: "Achats récurrents",
					url: "recurring_purchase_check",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["purchases", "recurring_purchase_check"],
					disabled: false,
				},
				{
					title: "Import de netlinks",
					url: "import_netlinks",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: true,
					path: ["netlink", "import_netlinks"],
					disabled: false,
				},
				{
					title: "Rapports",
					showDateFilter: false,
					showSocietyFilter: false,
					loadAllSocieties: false,
					url: "report",
					path: ["report"],
					disabled: true,
				},
				{
					title: "Analyse SEO",
					showDateFilter: true,
					showSocietyFilter: true,
					loadAllSocieties: false,
					url: "analysis",
					path: ["analysis"],
					disabled: true,
				},
				{
					title: "Keywords",
					url: "keyword",
					showDateFilter: true,
					showSocietyFilter: true,
					loadAllSocieties: false,
					path: ["analysis", "keyword"],
					disabled: false,
				},
				{
					title: "Performance",
					url: "performance",
					showDateFilter: true,
					showSocietyFilter: true,
					loadAllSocieties: false,
					path: ["analysis", "performance"],
					disabled: false,
				},
				{
					title: "Exploration",
					url: "exploration",
					showDateFilter: true,
					showSocietyFilter: true,
					loadAllSocieties: false,
					path: ["analysis", "exploration"],
					disabled: false,
				},
				{
					title: "Analyse sémantique",
					url: "analyse_semantique",
					showDateFilter: true,
					showSocietyFilter: true,
					loadAllSocieties: false,
					path: ["analysis", "analyse_semantique"],
					disabled: false,
				},
				{
					title: "Speed test",
					url: "pagespeed",
					showDateFilter: true,
					showSocietyFilter: true,
					loadAllSocieties: false,
					path: ["analysis", "pagespeed"],
					disabled: false,
				},
				{
					title: "Création",
					url: "entity/new",
					showDateFilter: true,
					showSocietyFilter: true,
					loadAllSocieties: true,
					path: ["new"],
					disabled: false,
				},
				{
					title: "Modification",
					url: "entity/update",
					showDateFilter: true,
					showSocietyFilter: true,
					loadAllSocieties: true,
					path: ["update"],
					disabled: false,
				},
			],
			relanceFilterObj: {},
			pageTitle: "",
			breadcrumData: [],
			showSocietyFilter: false,
			showDateFilter: false,
			// showStatFilters: false,
			loadAllSocieties: false,
			userSocietiesOptions: [],
			userSelectedSociety: null,
			showDatePopup: false,
			showAlertPopup: false,
			waiting_alert: 0,
			waiting_messages: 0,
			qbColor: "#2ca01c",
		};
	},
	created() {
		//console.log("created");
		let style = document.createElement("link");
		style.rel = "stylesheet";
		style.href =
			"https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..24,100..700,0..1,-50..200";
		document.head.appendChild(style);
		this.$store.dispatch("getAllSocieties");

		this.$store.dispatch("getAllSocietiesIdAndName").then(() => {
			this.$store.dispatch("getAllCollaborators").then(() => {
				this.$store.dispatch("getAllCollaboratorsAvatar").then(() => {});
			});
		});

		if (this.activeUser.role == 1) {
			let netlinkIndex = this.pagesTitleList.findIndex(
				(row) => row.url == "netlink"
			);
			if (netlinkIndex >= 0) {
				this.pagesTitleList[netlinkIndex].showSocietyFilter = false;
			}
		}
		// display popup budgetflexiblePopup
		// Paramas
		if (this.$route.query.flexibleMissionPopup) {
			this.$store.commit("TOGGLE_FLEXIBLE_POPUP", true);
		}
		if (this.$route.query.messageConsultant) {
			this.onclickMessageConsultant();
		}

		this.getPageInfo();
		if (this.$acl.check("commercial")) this.getNotificationsByCommercialId();
		if (this.$acl.check("sadmin") || this.$acl.check("admin"))
			this.getAllNotifications();
		this.getAllMessages();
		this.$store.dispatch("getPersonalNotificationList", this.activeUser.id);
	},

	mounted() {
		//console.log("mounted");
		//console.log(document.getElementById("navWrapper").clientHeight);
		store.dispatch(
			"updateHorizentalNavBarHeight",
			document.getElementById("navWrapper").clientHeight
		);
		window.onresize = () => {
			store.dispatch(
				"updateHorizentalNavBarHeight",
				document.getElementById("navWrapper").clientHeight
			);
		};
		setTimeout(() => {
			let obj = this.societies.filter(
				(society) => society.id == this.$route.query.targetSociety
			);
			this.userSelectedSociety = obj[0];
		}, 1000);
	},
	methods: {
		clearQueryParams() {
			this.$router.push({
				path: this.$router.path,
				query: { ...this.$router.query, flexibleMissionPopup: undefined },
			});
		},
		relanceCommercialPopupNotifcation() {
			this.$store.dispatch("updateRelanceFilter", {
				commercialFilter: this.activeUser.id.toString(),
				contractNumberFilter: "",
				societyFilter: "",
				endDateFilter: "",
				startDateFilter: "",
				typeFilter: [],
				statusFilter: "0",
			});
			this.relanceFilterObj = {
				commercialFilter: this.activeUser.id.toString(),
				contractNumberFilter: "",
				societyFilter: "",
				endDateFilter: "",
				startDateFilter: "",
				typeFilter: [],
				statusFilter: "0",
			};
			this.refreshListKey++;
			//this.isRcByUserId = true;
			this.showAlertPopup = true;
		},
		/**
		 * Open message consultant popup
		 */
		onclickMessageConsultant() {
			// this.showSocietyPopupActive = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(MessageConsultantPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					showPopup: true,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},
		flexiblePopUp() {
			this.refreshListKey++;
			//this.isRcByUserId = true;
			this.$store.commit("TOGGLE_FLEXIBLE_POPUP", true);
		},
		displayContactForm() {
			this.$router.push({
				name: "contactform",
				params: { userId: this.activeUser.id },
			});
		},
		showSocietyPopup() {
			//Initialisation des données pour le popup
			this.showSocietyPopupActive = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.userSelectedSociety,
					popupActive: this.showSocietyPopupActive,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
			//console.log("showSocietyPopup");
		},

		showSidebar() {
			this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
		},

		/**
		 * @function getAllNotifications notification counter for admin/sadmin
		 */
		getAllNotifications() {
			this.$http
				.get(this.apiUrl + "notifications/commercial/all")
				.then((res) => {
					this.waiting_alert = res.data.filter(
						(n) => n.notification_checked == 0
					).length;
				});
		},
		async getAllMessages() {
			try {
				this.allNotes = await Notes.getForNotes(this.activeUser.id);
				this.waiting_messages = this.allNotes.filter(
					(n) => n.notification_checked == 0
				).length;
			} catch (e) {
				console.log("TheNavbarVertival.vue - getAllMessages Error", e);
			}
		},

		/**
		 * @function getNotificationsByCommercialId notification counter for current user
		 */
		getNotificationsByCommercialId() {
			this.$http
				.get(
					this.apiUrl + "notifications/commercial/get/all/" + this.activeUser.id
				)
				.then((res) => {
					this.waiting_alert = res.data.filter(
						(n) => n.notification_checked == 0
					).length;
				});
		},

		getPageInfo() {
			// //console.log("this.$route.name", this.$route.name)
			let foundPage = this.pagesTitleList.find(
				(page) => page.url == this.$route.name
			);
			if (foundPage) {
				this.breadcrumData = [];
				for (let pageUrl of foundPage.path) {
					// //console.log("pageUrl", pageUrl)
					let foundPageUrl = this.pagesTitleList.find(
						(page) => page.url == pageUrl
					);
					if (foundPageUrl) {
						// //console.log("foundPageUrl", foundPageUrl)
						this.breadcrumData.push(foundPageUrl);
					}
				}
				this.pageTitle = foundPage.title;
				// this.showStatFilters = foundPage.showStatFilters
				this.showDateFilter = foundPage.showDateFilter;
				if (
					this.showSocietyFilter == false &&
					this.userSelectedSociety != null &&
					this.activeUser.role == 1
				) {
					this.userSelectedSociety = null;
				}
				this.showSocietyFilter = foundPage.showSocietyFilter;
				this.loadAllSocieties = foundPage.loadAllSocieties;
			} else {
				this.pageTitle = "";
				// this.showStatFilters = false
				this.showDateFilter = false;
				this.showSocietyFilter = false;
				this.loadAllSocieties = true;
			}
		},

		createSocietyList() {
			if (this.activeUser.role == 1) {
				if (this.loadAllSocieties == true) {
					this.userSocietiesOptions = this.societies;
				} else {
					let filledGSCAnalyticsSocieties = this.societies.filter(
						(society) => society.gsc_url != null
					);
					this.userSocietiesOptions = filledGSCAnalyticsSocieties;
				}
			} else {
				this.$http
					.get(this.apiUrl + "usersSocieties/get/u/" + this.activeUser.id)
					.then((res) => {
						let listOfSociety = res.data.map(
							(user_societies) => user_societies.id
						);
						this.userSocietiesOptions = this.societies.filter((society) =>
							listOfSociety.includes(society.id)
						);
						if (this.userSocietiesOptions.length == 1) {
							this.userSelectedSociety =
								this.userSocietiesOptions.length > 0
									? this.userSocietiesOptions[0]
									: null;
						}
					})
					.catch((err) => {
						//console.log(err);
					});
			}
		},

		setSelectedSociety(data) {
			this.$store.commit("SET_SELECTED_SOCIETY", data);
		},

		displayDatePopup() {
			this.showDatePopup = true;
		},

		closeDatePopup() {
			//console.log("closeDatePopup");
			this.showDatePopup = false;
		},

		testConnection() {
			window.open("https://rankwell.one/api/qb/askauth");
			this.$http
				.get(this.apiUrl + "qb/action/get_customers")
				.then((res, err) => {
					if (res)
						res.data.length > 0
							? (this.qbColor = "#2ca01c")
							: (this.qbColor = "red");
					if (err) this.qbColor = "red";
				})
				.catch((err) => {
					//console.log(err);
				});
		},
	},
};
</script>

<style scoped>
.btn-qb {
	user-select: none;
	width: 24px;
	height: 24px;
	border-radius: 15px;
	color: white;
	text-align: center;
	font-size: 15px;
	font-weight: 500;
	letter-spacing: -1.5px;
}
.btn-qb:hover {
	cursor: pointer;
}
.font-big-size {
	font-size: 20px;
}
#alert-commercial:hover {
	box-shadow: none;
}
</style>